import { API } from "@/lib/api";
import { labelFor } from "@/lib/categories";

const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const PRINT_WAIT = `<script>window.addEventListener('load',function(){var i=Array.prototype.slice.call(document.images);Promise.all(i.map(function(m){return m.complete?0:new Promise(function(r){m.onload=m.onerror=r;});})).then(function(){setTimeout(function(){window.print();},200);});});</script>`;

// Opens a print window with a grid of QR labels (1..N items). Returns false if
// the pop-up was blocked or the list is empty.
export function printQrLabels(items, title = "Étiquettes QR") {
  const list = (items || []).filter(Boolean);
  if (!list.length) return false;
  const w = window.open("", "_blank", "width=900,height=1000");
  if (!w) return false;
  const cards = list.map((it) => `
    <div class="label">
      <img src="${API}/items/${it.id}/qr.png" alt="QR" />
      <div class="desc">${esc(it.description || labelFor(it.category))}</div>
      ${it.storage_location ? `<div class="loc">📍 ${esc(it.storage_location)}</div>` : ""}
      <div class="brand">Findloop · scannez pour retrouver l'objet</div>
    </div>`).join("");
  w.document.write(`<!doctype html><html><head><title>${esc(title)}</title>
    <style>@page{margin:12mm}
    body{font-family:system-ui,Arial,sans-serif;color:#191A54;margin:0;padding:14px}
    h1{font-size:16px;margin:0 0 12px}
    .grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px}
    .label{border:1px solid #e5e7eb;border-radius:12px;padding:12px;text-align:center;page-break-inside:avoid}
    .label img{width:150px;height:150px}
    .desc{font-size:12px;font-weight:700;margin-top:6px;min-height:28px}
    .loc{font-size:15px;font-weight:800;margin-top:4px}
    .brand{font-size:9px;color:#8a8fb0;margin-top:6px}
    </style>${PRINT_WAIT}</head><body>
    <h1>${esc(title)} — ${list.length} objet(s)</h1>
    <div class="grid">${cards}</div></body></html>`);
  w.document.close();
  return true;
}
